

























































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import { ChainModule } from '@/store/modules/chain.module'
import Avatar from '@/components/Avatar.vue'
import ScrollView from '@/components/ScrollView.vue'
import Icon from '@/components/Icon.vue'
import { IUser } from '@zunta/configurations'
import CommissionsHistoryModal from './components/CommissionsHistoryModal.vue'
import Table from '@/components/tables/Table.vue'
import { ITableConfig } from '@/interfaces'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  components: {
    LoaderWrapper,
    Table,
    Card,
    Avatar,
    ScrollView,
    Icon,
    CommissionsHistoryModal
  }
})
export default class CommissionsPage extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  shouldShowCommissionHistory: boolean = false
  commissionHistoryUser: IUser | null = null

  isLoading: boolean = false

  config: ITableConfig = {
    useQuery: false,
    usePagination: false,
    fetchFunction: this.fetchBatch,
    columns: [
      {
        label: 'Type',
        key: 'type',
        width: 10
      },
      {
        label: 'Monthly Fee',
        key: 'monthlyFee',
        width: 10,
        class: 'text-right',
        headClass: 'bt-justify-content-end'
      },
      {
        label: 'Credit Card',
        key: 'creditCard',
        width: 10,
        class: 'text-right',
        headClass: 'bt-justify-content-end'
      },
      {
        label: 'Chargeback',
        key: 'chargeback',
        width: 10,
        class: 'text-right',
        headClass: 'bt-justify-content-end'
      },
      {
        label: '$ eCheck',
        key: 'echeck',
        width: 10,
        class: 'text-right',
        headClass: 'bt-justify-content-end'
      },
      {
        label: 'eCheck Over 10k',
        key: 'echeckOver',
        width: 10,
        class: 'text-right',
        headClass: 'bt-justify-content-end'
      },
      {
        label: 'Mailing',
        key: 'mailing',
        width: 10,
        class: 'text-right',
        headClass: 'bt-justify-content-end'
      },
      {
        label: 'Additional Pages',
        key: 'additionalPages',
        width: 10,
        class: 'text-right',
        headClass: 'bt-justify-content-end'
      },
      {
        label: 'Return Envelope',
        key: 'returnEnvelope',
        width: 10,
        class: 'text-right',
        headClass: 'bt-justify-content-end'
      },
      {
        label: 'Total',
        key: 'total',
        width: 10,
        class: 'text-right',
        headClass: 'bt-justify-content-end'
      }
    ]
  }

  get batchId () {
    return this.$route.params.batch
  }

  get userId () {
    return this.$route.params.user
  }

  get selectedBatch () {
    return this.$store.state.chain.selectedBatch
  }

  get batchUsersCommissions () {
    return this.$store.state.chain.batchUsersCommissions
  }

  get facilitiesCountStatistics () {
    return this.$store.state.chain.facilitiesCountStatistic
  }

  get totalGross () {
    const fields = [
      'monthlyFee',
      'grossCC',
      'grossECheckForMoreThan10k',
      'grossECheckPerTransaction',
      'grossMailing',
      'grossAdditionalPages',
      'grossReturnEnvelop'
    ]
    return this.calcSum(fields)
  }

  get totalCost () {
    const fields = [
      'CCCost',
      'eCheckCostPerTransaction',
      'eCheckCostForMoreThan10k',
      'mailingCost',
      'additionalPagesCost',
      'returnEnvelopCost'
    ]
    return this.calcSum(fields)
  }

  get totalNet () {
    const fields = [
      'monthlyFee',
      'netCC',
      'netECheckPerTransaction',
      'netECheckForMoreThan10k',
      'netMailing',
      'netReturnEnvelop',
      'netAdditionalPages'
    ]
    return this.calcSum(fields)
  }

  calcSum (fields: string[]) {
    let total = 0
    fields.forEach((field: string) => {
      total += +this.selectedBatch[field] || 0
    })
    return total
  }

  get rows () {
    const currency: Function = (this.$options.filters as any).currency as Function
    return [
      {
        type: 'Volume',
        monthlyFee: this.selectedBatch.facilities.length,
        creditCard: currency(this.selectedBatch.CCVolume),
        chargeback: currency(this.selectedBatch.chargebackVolume, '', 0),
        echeck: currency(this.selectedBatch.eCheckTransactionVolume, '', 0),
        echeckOver: currency(this.selectedBatch.eCheckForMoreThan10kVolume),
        mailing: currency(this.selectedBatch.mailingEnvelopVolume, '', 0),
        additionalPages: currency(this.selectedBatch.additionalPageVolume, '', 0),
        returnEnvelope: currency(this.selectedBatch.returnEnvelopVolume, '', 0),
        total: 'N/A'
      },
      {
        type: 'Transaction Count',
        monthlyFee: 'N/A',
        creditCard: this.selectedBatch.creditCardTransactionCount ? currency(this.selectedBatch.creditCardTransactionCount, '', 0) : 'N/A',
        chargeback: this.selectedBatch.chargebackTransactionCount ? currency(this.selectedBatch.chargebackTransactionCount, '', 0) : 'N/A',
        echeck: this.selectedBatch.echeckPerTransactionCount ? currency(this.selectedBatch.echeckPerTransactionCount, '', 0) : 'N/A',
        echeckOver: this.selectedBatch.echeckMoreThan10kTransactionCount ? currency(this.selectedBatch.echeckMoreThan10kTransactionCount, '', 0) : 'N/A',
        mailing: 'N/A',
        additionalPages: 'N/A',
        returnEnvelope: 'N/A',
        total: 'N/A'
      },
      {
        type: 'Gross Billing',
        monthlyFee: this.selectedBatch.monthlyFee ? currency(this.selectedBatch.monthlyFee) : 'N/A',
        creditCard: this.selectedBatch.grossCC ? currency(this.selectedBatch.grossCC) : 'N/A',
        chargeback: this.selectedBatch.chargebackFee ? currency(this.selectedBatch.chargebackFee) : 'N/A',
        echeck: this.selectedBatch.grossECheckPerTransaction ? currency(this.selectedBatch.grossECheckPerTransaction) : 'N/A',
        echeckOver: this.selectedBatch.grossECheckForMoreThan10k ? currency(this.selectedBatch.grossECheckForMoreThan10k) : 'N/A',
        mailing: this.selectedBatch.grossMailing ? currency(this.selectedBatch.grossMailing) : 'N/A',
        additionalPages: this.selectedBatch.grossAdditionalPages ? currency(this.selectedBatch.grossAdditionalPages) : 'N/A',
        returnEnvelope: this.selectedBatch.grossReturnEnvelop ? currency(this.selectedBatch.grossReturnEnvelop) : 'N/A',
        total: currency(this.totalGross)
      },
      {
        type: 'Cost',
        monthlyFee: 0,
        creditCard: this.selectedBatch.CCCost ? currency(this.selectedBatch.CCCost) : 'N/A',
        chargeback: 'N/A',
        echeck: this.selectedBatch.eCheckCostPerTransaction ? currency(this.selectedBatch.eCheckCostPerTransaction) : 'N/A',
        echeckOver: this.selectedBatch.eCheckCostForMoreThan10k ? currency(this.selectedBatch.eCheckCostForMoreThan10k) : 'N/A',
        mailing: this.selectedBatch.mailingCost ? currency(this.selectedBatch.mailingCost) : 'N/A',
        additionalPages: this.selectedBatch.additionalPagesCost ? currency(this.selectedBatch.additionalPagesCost) : 'N/A',
        returnEnvelope: this.selectedBatch.returnEnvelopCost ? currency(this.selectedBatch.returnEnvelopCost) : 'N/A',
        total: currency(this.totalCost)
      },
      {
        type: 'Net Billing',
        monthlyFee: this.selectedBatch.monthlyFee ? currency(this.selectedBatch.monthlyFee) : 'N/A',
        creditCard: this.selectedBatch.netCC ? currency(this.selectedBatch.netCC) : 'N/A',
        chargeback: 'N/A',
        echeck: this.selectedBatch.netECheckPerTransaction ? currency(this.selectedBatch.netECheckPerTransaction) : 'N/A',
        echeckOver: this.selectedBatch.netECheckForMoreThan10k ? currency(this.selectedBatch.netECheckForMoreThan10k) : 'N/A',
        mailing: this.selectedBatch.netMailing ? currency(this.selectedBatch.netMailing) : 'N/A',
        additionalPages: this.selectedBatch.netAdditionalPages ? currency(this.selectedBatch.netAdditionalPages) : 'N/A',
        returnEnvelope: this.selectedBatch.netReturnEnvelop ? currency(this.selectedBatch.netReturnEnvelop) : 'N/A',
        total: currency(this.totalNet)
      },
      {
        type: 'Total OutStanding',
        monthlyFee: this.selectedBatch.totalMonthlyOutstanding ? currency(this.selectedBatch.totalMonthlyOutstanding) : 'N/A',
        creditCard: this.selectedBatch.totalCreditCardOutstanding ? currency(this.selectedBatch.totalCreditCardOutstanding) : 'N/A',
        chargeback: this.selectedBatch.totalChargebackOutstanding ? currency(this.selectedBatch.totalChargebackOutstanding) : 'N/A',
        echeck: this.selectedBatch.totalEcheckPerTransactionOutstanding ? currency(this.selectedBatch.totalEcheckPerTransactionOutstanding) : 'N/A',
        echeckOver: this.selectedBatch.totalEcheckMoreThan10kOutstanding ? currency(this.selectedBatch.totalEcheckMoreThan10kOutstanding) : 'N/A',
        mailing: this.selectedBatch.totalMailingOutstanding ? currency(this.selectedBatch.totalMailingOutstanding) : 'N/A',
        additionalPages: this.selectedBatch.totalAdditionalPagesOutstanding ? currency(this.selectedBatch.totalAdditionalPagesOutstanding) : 'N/A',
        returnEnvelope: this.selectedBatch.totalReturnEnvelopeOutstanding ? currency(this.selectedBatch.totalReturnEnvelopeOutstanding) : 'N/A',
        total: this.selectedBatch.totalOutStanding ? currency(this.selectedBatch.totalOutStanding) : 'N/A'
      }
    ]
  }

  async mounted () {
    try {
      this.isLoading = true
      await this.chainModuleInstance.fetchBatchUsersCommissions(+this.batchId)
    } finally {
      this.isLoading = false
    }
  }

  async fetchBatch () {
    if (!this.selectedBatch) {
      return
    }
    await this.chainModuleInstance.fetchFaciltiiesCountStatistic(this.selectedBatch.facilities || [])
  }

  showCommissionsHistory (commission: any) {
    this.shouldShowCommissionHistory = true
    this.commissionHistoryUser = commission.user
  }
}
